<template>
  <div>
    <el-table
      :data="tableData"
      :summary-method="getSummaries"
      style="width: 100%;margin-top:20px"
      row-key="id"
      show-summary
      border
      class="report multifunctional-table dic-sub-table-style01"
    >
      <el-table-column type="index" label="序号" width="51" align="left" />
      <el-table-column prop="annual" label="年度" align="left" />
      <el-table-column prop="scalingNum" align="left" label="中标数量" />
      <el-table-column
        prop="scalingAmount"
        header-align="left"
        align="right"
        label="中标金额"
      >
        <template slot-scope="{ row }">
          <span class="amountOfmoney">{{
            row.scalingAmount.toString() | NumFormat(2)
          }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "supplier-summary-table",
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      clientHeight: 0,
      tableHeight: 0,
      labelPosition: "right",
      isShow: false,
      input: "",
      value: ""
    };
  },
  mounted() {
    this.clientHeight = document.body.clientHeight;
    window.onresize = () => {
      return (() => {
        this.clientHeight = document.body.clientHeight;
        // console.log(this.clientHeight)
      })();
    };
  },
  methods: {
    NumFormat(value, num) {
      if (!value) return "0.00";
      var intPart = parseInt(Number(value.replace(/,/g, "")).toString(), 0); // 获取整数部分
      var intPartFormat = intPart
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
      var floatPart = "."; // 预定义小数部分
      for (var i = 1; i <= num; i++) {
        floatPart += "0";
      }
      var value2Array = value.split(".");
      // 判断是否为小数
      if (value2Array.length === 2) {
        // 2表示数据有小数位
        floatPart = value2Array[1].toString(); // 拿到小数部分
        if (floatPart.length == num) {
          return intPartFormat + "." + floatPart;
        } else {
          if (floatPart.length > num) {
            if (Number(floatPart.substring(num, floatPart.length)) >= 5) {
              floatPart = (Number(floatPart.substring(0, num)) + 1).toString();
              return intPartFormat + "." + floatPart;
            } else {
              floatPart = floatPart.substring(0, num);
              return intPartFormat + "." + floatPart;
            }
          } else {
            var d = "";
            for (var j = 1; j <= num - floatPart.length; j++) {
              d += "0";
            }
            floatPart = floatPart + d;
            return intPartFormat + "." + floatPart;
          }
        }
      } else {
        // 没有小数位
        return intPartFormat + floatPart;
      }
    },
    getSummaries(param) {
      // console.log('-----------')
      // console.log(param)
      // console.log('-----------')
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (
          !values.every(value => isNaN(value)) &&
          column.property != "annual"
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            // console.log(value)
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // console.log(index)
          if (index === 3) {
            sums[index] = this.NumFormat(sums[index].toFixed(2));
          } else {
            // eslint-disable-next-line no-self-assign
            sums[index] = sums[index];
          }
        } else {
          sums[index] = "————";
        }
      });
      return sums;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.el-table.report .el-table__footer-wrapper td {
  border-top: 1px solid #edf2fc !important;
}
</style>
